@if (true) {
<div class="wrap-x wrap-l">
    <!-- HEADER -->
    <div class="center overflow-hidden">
        <h1 class="p-l-12 p-r-12 pos-relative w-12-s title-decoration p-t-5-s"
            [ngClass]="{'p-r-6-s p-l-6-s': isThreeImagesVariant}"
            sizeClass="XL:h1, MS:h2"
            *iCms="'title' of component; skipEmpty: true"></h1>
        <h2 class="m-t-1 p1"
            *iCms="'subtitle' of component; skipEmpty: true"
            [ngClass]="{'p-r-4-s p-l-4-s': isThreeImagesVariant}"></h2>
        @if (component.show_cta_subtitle) {
        <a class="button-inline m-t-3"
           [style.color]="component.cta_subtitle_color"
           [routerLink]="component.cta_subtitle_link">
            <span class="button__body"
                  *iCms="'cta_subtitle_copy' of component"
                  text>
            </span>
        </a>
        }
    </div>
    <!-- IMAGES -->
    @if (component.image_blocks?.length) {
    <div class="m-t-5">
        <!--------- TWO IMAGES VARIANT -->
        @if (component.variant === 'two_images') {
        <div class="w-12">
            @for (picture of component.image_blocks | slice:0:2; track $index) {
            <ng-template *ngTemplateOutlet="bigimages; context: {$implicit: picture}">
            </ng-template>
            }
        </div>
        }
        <!--------- THREE IMAGES VARIANT -->
        @if (isThreeImagesVariant) {
        <div class="w-12">
            <!-- DESKTOP -->
            <ng-container *ifSize="'XL'">
                @for (picture of component.image_blocks | slice:0:3; track $index; let i = $index;
                let isFirst = $first; let isLast = $last) {
                <ng-template *ngTemplateOutlet="bigimages; context: {$implicit: picture, first: isFirst, last: isLast}">
                </ng-template>
                }
            </ng-container>
            <!-- MOBILE -->
            <ng-container *ifSize="'SM'">
                <swiper [slidesPerView]="'auto'"
                        [centeredSlides]="true"
                        [loop]="true"
                        [spaceBetween]="0"
                        class="m-t-5">
                    @for (picture of component.image_blocks | slice:0:3; track $index) {
                    <ng-template swiperSlide>
                        <ng-template *ngTemplateOutlet="bigimages; context: {$implicit: picture}"></ng-template>
                    </ng-template>
                    }
                </swiper>
            </ng-container>
        </div>
        }
        <!-------- FIVE IMAGES VARIANT -->
        @if (component.variant === 'five_images') {
        <div class="flex flex-direction-row"
             [ngClass]="component.reverse ? 'flex-column-reverse-s' : 'flex-column-s'">
            <!-- BIG IMAGE -->
            @for (picture of component.image_blocks | slice:0:1; track $index) {
            <ng-template *ngTemplateOutlet="bigimages; context: {$implicit: picture}">
            </ng-template>
            }
            <!-- FOUR IMAGES MODULE -->
            @if (true) {
            <div class="w-6 w-12-s flex flex-wrap">
                @for (picture of component.image_blocks | slice:1:5; track $index; let odd = $odd) {
                <div class="w-6 pos-relative p-a-1"
                     [ngClass]="odd ? 'p-r-0-s' : 'p-l-0-s'">
                    <shop-this-look [content]="picture"></shop-this-look>
                    <href [link]="picture.link"
                          class="block">
                        <div class="ratio-3-4 overflow-hidden">
                            <shell></shell>
                            <img class="rf"
                                 [image]="picture.image">
                        </div>
                        @if (picture.overlayText) {
                        <text-overlay [data]="picture" />
                        }
                        <p class="p-r-2 p1 fw-bold underline z-1"
                           [ngClass]="[component.description_below ? 'p-t-1' : 'pos-absolute bottom-4 left-3 bottom-3-s left-2-s col-w',
                                     component.description_below && !odd ? 'p-l-2-s' : '',
                                     !component.description_below && odd ? 'left-4-s' : '']">
                            <span *iCms="'description' of picture"></span>
                        </p>
                    </href>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
    }
</div>
}

<!-- TEMPLATE FOR BIG IMAGES -->
<ng-template #bigimages
             let-picture
             let-isFirst="first"
             let-isLast="last">
    <div class="w-12-s p-r-0-s p-l-0-s"
         [ngClass]="{'w-6 p-a-1' : !isThreeImagesVariant,
                    'w-4 w-12-m p-r-0-m p-l-0-m' : isThreeImagesVariant,
                    'p-r-2' : isFirst && isThreeImagesVariant,
                    'p-l-2' : isLast && isThreeImagesVariant,
                    'p-l-1 p-r-1': (!isFirst && !isLast && isThreeImagesVariant)}">
        <div class="w-12 pos-relative"
             [ngClass]="{'p-r-2-s p-l-2-s p-r-2-m p-l-2-m': isThreeImagesVariant}">
            <shop-this-look [content]="picture"></shop-this-look>
            <href [link]="picture.link"
                  [hrefClass]="'w-12'">
                <div class="ratio-3-4 overflow-hidden"
                     [ngClass]="{'p-b-3 p-b-0-s': component.description_below}">

                    <shell></shell>
                    @if (picture.image) {
                    <img class="rf z-1"
                         [image]="picture.image" />
                    }


                    @if (picture.contentVariant === contentVariant.video) {
                    @if (picture.contentVideoProvider === contentVideoProvider.vimeo) {
                    <vimeo-player class="rf z-2"
                                  [video-id]="picture.contentVideoId"
                                  [background]="true"
                                  [loop]="true">
                    </vimeo-player>
                    }
                    @if (picture.contentVideoProvider === contentVideoProvider.youtube) {
                    <youtube-player class="rf z-2"
                                    [video-id]="picture.contentVideoId">
                    </youtube-player>
                    }
                    }
                </div>

                @if (picture.overlayText) {
                <text-overlay [data]="picture" />
                }

                @if (!picture.overlayText || component.description_below) {
                <span class="p1 z-1"
                      [ngClass]="{'bottom-4 not-three-image-variant': !component.description_below && !isThreeImagesVariant,
                              'bottom-5 left-3 m-l-3-m m-l-3-s m-b-3-m m-b-3-s image-description': !component.description_below && isThreeImagesVariant,
                              'button-inline-white': !component.description_below,
                              'button-inline-1 left-0 p-t-1': component.description_below}">
                    <span *iCms="'description' of picture"></span>
                </span>
                }
            </href>
        </div>
    </div>
</ng-template>